<template>

  <div class="container-fluid">
    <p><small>Selecciona fechas para filtrar movimientos</small></p>
    <form @submit.prevent="submit" novalidate>
      <fieldset>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-33">
             <DatePicker
              name="initialDate"
              v-model.trim="userInteraction.initialDate"
              :format="dateFormat"
              :monday-first="true"
              :disabled-dates="{from: new Date(), to: new Date(1900, 0, 0)}"
              :language="es"
              placeholder="Fecha de inicio (dd-mm-aaaa)">
            </DatePicker>
          </div>
          <div class="column column-xs-100 column-sm-33">
             <DatePicker
              name="finalDate"
              v-model.trim="userInteraction.finalDate"
              :format="dateFormat"
              :monday-first="true"
              :disabled-dates="{from: new Date(), to: new Date(1900, 0, 0)}"
              :language="es"
              placeholder="Fecha de término (dd-mm-aaaa)">
            </DatePicker>
          </div>
        </div>
        <div class="row-responsive">
          <div class="column">
            <button class="button" @click.prevent="submit()">Filtrar</button>
            <button class="button" v-if="clearFilter" @click.prevent="submit(true)">Borrar filtro</button>
          </div>
        </div>
      </fieldset>
    </form>
  </div>

</template>

<script>

import DatePicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import mixins from '@/mixins/index'

export default {
  name: 'DashboardVirtualAccountsDateFilter',
  components: {
    DatePicker
  },
  mixins: [ mixins ],
  data () {
    return {
      es: es,
      clearFilter: false,
      userInteraction: {
        initialDate: '',
        finalDate: ''
      }
    }
  },
  methods: {
    submit: function (clearFilter = false) {
      let finalInitialDate = this.reverseBirthDate(
        this.dateFormat(this.userInteraction.initialDate))
      let finalFinalDate = this.reverseBirthDate(
        this.dateFormat(this.userInteraction.finalDate))

      if (clearFilter) {
        finalInitialDate = ''
        finalFinalDate = ''
        this.clearFilter = false
        this.userInteraction.initialDate = ''
        this.userInteraction.finalDate = ''
      } else {
        this.clearFilter = true
      }

      this.$emit(
        'requiredParams',
        {
          min_date: finalInitialDate,
          max_date: finalFinalDate,
          comeFromFilter: true
        }
      )
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/dashboardVirtualAccount/DashboardVirtualAccountsDateFilter.vue